/*jshint esversion: 9 */

import * as actionTypes from "../actions/actionTypes";
import axios from "axios";
// import { hasValue, LogDebug } from "../../shared/utility";
import {
  doLog,
  getAppOptions,
  getServerAppPath,
  hasValue,
} from "../../shared/utility";

//--------------------------------------------------------------------------------------
export const runTransactionStart = (transDesc) => {
  if (doLog()) console.log("[runTransactionStart] transDesc:", transDesc);
  return {
    type: actionTypes.TRANSACTION_START,
    result: null,
    error: null,
    transDesc: transDesc,
  };
};

export const runTransactionSuccess = (result, transDesc) => {
  if (doLog()) console.log("[runTransactionSuccess] transDesc:", transDesc);
  if (doLog()) console.log("[runTransactionSuccess] result:", result);
  return {
    type: actionTypes.TRANSACTION_SUCCESS,
    result: result,
    transDesc: transDesc,
  };
};

export const runTransactionFail = (error) => {
  return {
    type: actionTypes.TRANSACTION_FAIL,
    error: error,
  };
};

export const clearWebAgencyList = () => {
  return {
    type: actionTypes.CLEAR_WEBAGENCY_LIST,
    webAgencyList: null,
  };
};

export const clearTransactionResult = () => {
  return {
    type: actionTypes.CLEAR_TRANSACTION_RESULT,
    result: null,
    error: null,
  };
};

export const clearTransDesc = () => {
  return {
    type: actionTypes.CLEAR_TRANS_DESC,
    transDesc: null,
  };
};

export const runTransaction = (transactionOptions, token, transDesc) => {
  return (dispatch) => {
    dispatch(runTransactionStart(transDesc));
    //if (doLog()) console.log("transactions_actions.runTransaction state:" + this.state);
    const transaction = "ciddb";
    const jsonResult = true;
    const timeoutSecs = 10;
    const requestData = {
      transactionType: transaction,
      options: transactionOptions,
      timeoutSecs: timeoutSecs,
      jsonResult: jsonResult,
    };

    const options = {
      timeout: 5000, // 5 seconds idle timeout
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    if (doLog())
      console.log("[runTransaction] serverAppPath:" + getServerAppPath());
    //const url = "transaction/citizenweb";
    const url = "transaction/" + getServerAppPath();

    if (doLog()) console.log("[runTransaction] requestData:", requestData);

    axios
      .post(url, requestData, options)
      .then((response) => {
        //if (doLog()) console.log(response);
        let responseData = response.data;
        //if (doLog()) console.log('responseData:',responseData);
        //if (doLog()) console.log('response:',response);
        if (typeof responseData === "string" && !responseData.startsWith("{")) {
          let pos = responseData.indexOf("{");
          //if (doLog()) console.log('pos:',pos);
          if (pos !== -1) {
            responseData = JSON.parse(responseData.substring(pos));
            //if (doLog()) console.log('new responseData:',responseData);
          }
        }
        if (doLog())
          console.log("[runTransaction] responseData:", responseData);
        let message = "";
        if (response === "") {
          dispatch(runTransactionFail("Error sending request"));
        } else if (responseData.status === "Failure") {
          message = responseData.result;
          if (doLog()) console.log("[runTransaction] message:", message);
          dispatch(runTransactionFail(message));
        } else {
          if (doLog())
            console.log("[runTransaction] result:", responseData.result);
          dispatch(runTransactionSuccess(responseData.result, transDesc));
        }
      })
      .catch((err) => {
        if (doLog()) console.log("[runTransaction] err:", err);
        dispatch(runTransactionFail(err));
      });
  };
};

//--------------------------------------------------------------------------------------
export const fetchConfigurationStart = () => {
  // if (doLog()) console.log('[fetchConfigurationStart]');
  return {
    type: actionTypes.FETCH_CONFIGURATION_START,
  };
};

export const fetchConfigurationSuccess = (configuration, agencyCode) => {
  if (doLog())
    console.log("[fetchConfigurationSuccess]configuration:", configuration);
  return {
    type: actionTypes.FETCH_CONFIGURATION_SUCCESS,
    configuration: configuration,
    agencyCode: agencyCode,
  };
};

export const fetchConfigurationFail = (error) => {
  if (doLog()) console.log("[fetchConfigurationFail] error:", error);
  return {
    type: actionTypes.FETCH_CONFIGURATION_FAIL,
    configurationErrorMsg: error,
  };
};

export const fetchConfiguration = (agencyCode, token) => {
  if (doLog()) console.log("fetchConfiguration agencyCode:", agencyCode);
  return (dispatch) => {
    dispatch(fetchConfigurationStart());
    if (agencyCode === "admin") {
      // return dummy configuration
      const dummyConfiguration = {
        ori: "",
        name: "Core Technology Corporation",
        addressText: "",
        // logoName: "talon.ico",
        logoName: "Core circle white.png",
        logoPerson: "",
        logoPersonTitle: "",
        logoWidth: "90",
        logoHeight: "90",
        waterMarkText: "",
        ciddbConnectionName: "",
      };
      dispatch(fetchConfigurationSuccess(dummyConfiguration, agencyCode));
    } else {
      const transaction = "ciddb";
      const jsonResult = true;
      const timeoutSecs = 10;
      const requestData = {
        transactionType: transaction,
        options: "GetCitizenWebAgency~" + agencyCode,
        timeoutSecs: timeoutSecs,
        jsonResult: jsonResult,
      };

      const options = {
        timeout: 5000, // 5 seconds idle timeout
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      // const url = "transaction/citizenweb";
      const url = "transaction/" + getServerAppPath();

      if (doLog()) console.log("fetchConfiguration requestData:", requestData);

      axios
        .post(url, requestData, options)
        .then((response) => {
          //if (doLog()) console.log(response);
          let responseData = response.data;
          //if (doLog()) console.log('responseData:',responseData);
          //if (doLog()) console.log('response:',response);
          if (
            typeof responseData === "string" &&
            !responseData.startsWith("{")
          ) {
            let pos = responseData.indexOf("{");
            //if (doLog()) console.log('pos:',pos);
            if (pos !== -1) {
              responseData = JSON.parse(responseData.substring(pos));
              //if (doLog()) console.log('new responseData:',responseData);
            }
          }
          if (doLog()) console.log("responseData:", responseData);
          let message = "";
          if (response === "") {
            dispatch(fetchConfigurationFail("Error sending request"));
          } else if (responseData.status === "Failure") {
            message = responseData.result;
            if (doLog()) console.log("message:", message);
            dispatch(fetchConfigurationFail(message));
          } else {
            if (doLog()) console.log("result:", responseData.result);
            const data = responseData.result["CITIZENWEBAGENCY"];
            const fetchedConfiguration = {
              ori: data.ORI,
              name: data.NAME,
              addressText: data.ADDRESSTEXT,
              logoName: data.LOGOFILENAME,
              logoPerson: data.LOGOPERSONNAME,
              logoPersonTitle: data.LOGOPERSONTITLE,
              logoWidth: data.LOGOWIDTH,
              logoHeight: data.LOGOHEIGHT,
              waterMarkText: data.WATERMARKTEXT,
              ciddbConnectionName: data.CIDDBCONNECTIONNAME,
              incidentPrefix: data.INCIDENTPREFIX,
            };
            dispatch(
              fetchConfigurationSuccess(fetchedConfiguration, agencyCode)
            );
          }
        })
        .catch((err) => {
          // if (doLog()) console.log('[fetchConfigurationFail] err:', err);
          dispatch(fetchConfigurationFail(err));
        });
    }
  };
};

//--------------------------------------------------------------------------------------
export const fetchIncidentTypeListStart = () => {
  // if (doLog()) console.log('[fetchIncidentTypeListStart]');
  return {
    type: actionTypes.FETCH_INCIDENTTYPE_LIST_START,
  };
};

export const fetchIncidentTypeListSuccess = (
  incidentTypeList,
  incidentTypeDataList
) => {
  if (doLog())
    console.log(
      "[fetchIncidentTypeListSuccess]incidentTypeList:",
      incidentTypeList
    );
  return {
    type: actionTypes.FETCH_INCIDENTTYPE_LIST_SUCCESS,
    incidentTypeList: incidentTypeList,
    incidentTypeDataList: incidentTypeDataList,
  };
};

export const fetchIncidentTypeListFail = (error) => {
  if (doLog()) console.log("[fetchIncidentTypeListFail] error:", error);
  return {
    type: actionTypes.FETCH_INCIDENTTYPE_LIST_FAIL,
    incidentTypeErrorMsg: error,
  };
};

export const fetchIncidentTypeList = (ori, token) => {
  return (dispatch) => {
    if (doLog()) console.log("transactions_actions.fetchIncidentTypeList");
    dispatch(fetchIncidentTypeListStart());
    const transaction = "ciddb";
    const jsonResult = true;
    const timeoutSecs = 10;
    const requestData = {
      transactionType: transaction,
      options: "GetCitizenIncidentTypes~" + ori,
      timeoutSecs: timeoutSecs,
      jsonResult: jsonResult,
    };

    const options = {
      timeout: 5000, // 5 seconds idle timeout
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    // const url = "transaction/citizenweb";
    const url = "transaction/" + getServerAppPath();

    if (doLog())
      console.log(
        "transactions_actions.fetchIncidentTypeList requestData:",
        requestData
      );

    axios
      .post(url, requestData, options)
      .then((response) => {
        //if (doLog()) console.log(response);
        let responseData = response.data;
        //if (doLog()) console.log('responseData:',responseData);
        //if (doLog()) console.log('response:',response);
        if (typeof responseData === "string" && !responseData.startsWith("{")) {
          let pos = responseData.indexOf("{");
          //if (doLog()) console.log('pos:',pos);
          if (pos !== -1) {
            responseData = JSON.parse(responseData.substring(pos));
            //if (doLog()) console.log('new responseData:',responseData);
          }
        }
        if (doLog())
          console.log(
            "transactions_actions.fetchIncidentTypeList responseData:",
            responseData
          );
        let message = "";
        if (response === "") {
          dispatch(fetchIncidentTypeListFail("Error sending request"));
        } else if (responseData.status === "Failure") {
          message = responseData.result;
          if (doLog()) console.log("message:", message);
          dispatch(fetchIncidentTypeListFail(message));
        } else {
          if (doLog())
            console.log(
              "transactions_actions.fetchIncidentTypeList result:",
              responseData.result
            );
          const appOptions = getAppOptions();
          if (doLog()) console.log('transactions_actions.fetchIncidentTypeList appOptions:',appOptions);
          const fetchedList = [];
          const fetchedTypeList = [];
          for (let key in responseData.result) {
            let permitted = true;
            const data = responseData.result[key];
            // if (doLog()) console.log('transactions_actions.fetchIncidentTypeList key:',key);
            // if (doLog()) console.log('transactions_actions.fetchIncidentTypeList data:',data);
            const permission = data.PERMISSIONNAME;
            // if (doLog()) console.log('transactions_actions.fetchIncidentTypeList permission:',permission);
            if (hasValue(permission) && typeof permission === "string" && permission.length > 0) {
              permitted = false;
              const permissionOption = appOptions[permission];
              if (doLog()) console.log('transactions_actions.fetchIncidentTypeList data:',data);
              if (doLog()) console.log('transactions_actions.fetchIncidentTypeList permissionOption:',permissionOption);
              if (
                hasValue(permissionOption) &&
                permissionOption.toUpperCase().startsWith("T")
              ) {
                permitted = true;
              }
              if (doLog()) console.log('transactions_actions.fetchIncidentTypeList permitted:',permitted);
            }
            if (permitted) {
              fetchedTypeList.push({
                value: data.INCIDENTTYPE,
                data: data,
              });
              fetchedList.push({
                value: data.INCIDENTTYPE,
                label: data.DESCRIPTION,
              });
            }
          }
          dispatch(fetchIncidentTypeListSuccess(fetchedList, fetchedTypeList));
        }
      })
      .catch((err) => {
        // if (doLog()) console.log('[fetchConnectionListFail] err:', err);
        dispatch(fetchIncidentTypeListFail(err));
      });
  };
};

//--------------------------------------------------------------------------------------
export const addToCustomTextArray = (item) => {
  if (doLog()) console.log("[addToCustomTextArray actions] item:", item);
  return {
    type: actionTypes.ADD_TO_CUSTOMTEXT_ARRAY,
    item: item,
  };
};

export const setCustomTextArray = (customTextArray) => {
  if (doLog())
    console.log(
      "[setCustomTextArray actions] customTextArray:",
      customTextArray
    );
  return {
    type: actionTypes.SET_CUSTOMTEXT_ARRAY,
    customTextArray: customTextArray,
  };
};

export const clearCustomTextList = () => {
  if (doLog()) console.log("[clearCustomTextList actions]");
  return {
    type: actionTypes.CLEAR_CUSTOMTEXT_LIST,
    customTextList: null,
  };
};

export const fetchCustomTextListStart = () => {
  if (doLog()) console.log("[fetchCustomTextListStart]");
  return {
    type: actionTypes.FETCH_CUSTOMTEXT_LIST_START,
  };
};

export const fetchCustomTextListSuccess = (customTextList) => {
  if (doLog())
    console.log("[fetchCustomTextListSuccess]customTextList:", customTextList);
  return {
    type: actionTypes.FETCH_CUSTOMTEXT_LIST_SUCCESS,
    customTextList: customTextList,
  };
};

export const fetchCustomTextListFail = (error) => {
  if (doLog()) console.log("[fetchCustomTextListFail] error:", error);
  return {
    type: actionTypes.FETCH_CUSTOMTEXT_LIST_FAIL,
    customTextErrorMsg: error,
  };
};

export const fetchCustomTextList = (agencyCode, token) => {
  return (dispatch) => {
    if (doLog()) console.log("transactions_actions.fetchCustomTextList");
    dispatch(fetchCustomTextListStart());
    const transaction = "ciddb";
    const jsonResult = true;
    const timeoutSecs = 10;
    const requestData = {
      transactionType: transaction,
      options: "GetCitizenWebCustomText~" + agencyCode,
      timeoutSecs: timeoutSecs,
      jsonResult: jsonResult,
    };

    const options = {
      timeout: 5000, // 5 seconds idle timeout
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    // const url = "transaction/citizenweb";
    const url = "transaction/" + getServerAppPath();

    if (doLog())
      console.log(
        "transactions_actions.fetchCustomTextList requestData:",
        requestData
      );

    axios
      .post(url, requestData, options)
      .then((response) => {
        //if (doLog()) console.log(response);
        let responseData = response.data;
        //if (doLog()) console.log('responseData:',responseData);
        //if (doLog()) console.log('response:',response);
        if (typeof responseData === "string" && !responseData.startsWith("{")) {
          let pos = responseData.indexOf("{");
          //if (doLog()) console.log('pos:',pos);
          if (pos !== -1) {
            responseData = JSON.parse(responseData.substring(pos));
            //if (doLog()) console.log('new responseData:',responseData);
          }
        }
        if (doLog())
          console.log(
            "transactions_actions.fetchCustomTextList responseData:",
            responseData
          );
        let message = "";
        if (response === "") {
          dispatch(fetchCustomTextListFail("Error sending request"));
        } else if (responseData.status === "Failure") {
          message = responseData.result;
          if (doLog()) console.log("message:", message);
          dispatch(fetchCustomTextListFail(message));
        } else {
          if (doLog()) console.log("result:", responseData.result);
          const fetchedList = [];
          for (let key in responseData.result) {
            const data = responseData.result[key];
            // if (doLog()) console.log('key:',key);
            // if (doLog()) console.log('data:',data);
            fetchedList.push({
              data: data,
            });
          }
          dispatch(fetchCustomTextListSuccess(fetchedList));
        }
      })
      .catch((err) => {
        // if (doLog()) console.log('[fetchCustomTextListFail] err:', err);
        dispatch(fetchCustomTextListFail(err));
      });
  };
};

export const clearIncidentDetails = () => {
  if (doLog()) console.log("[clearIncidentDetails actions]");
  return {
    type: actionTypes.CLEAR_INCIDENT_DETAILS,
    incidentDetails: null,
  };
};

export const fetchIncidentDetailsStart = () => {
  if (doLog()) console.log("[fetchIncidentDetails actions]");
  return {
    type: actionTypes.FETCH_INCIDENT_DETAILS_START,
  };
};

export const fetchIncidentDetailsSuccess = (incidentDetails) => {
  if (doLog())
    console.log(
      "[fetchIncidentDetailsSuccess]incidentDetails:",
      incidentDetails
    );
  return {
    type: actionTypes.FETCH_INCIDENT_DETAILS_SUCCESS,
    incidentDetails: incidentDetails,
  };
};

export const fetchIncidentDetailsFail = (error) => {
  if (doLog()) console.log("[fetchIncidentDetailsFail] error:", error);
  return {
    type: actionTypes.FETCH_INCIDENT_DETAILS_FAIL,
    incidentDetailsErrorMsg: error,
  };
};

export const fetchIncidentDetails = (token, ori, id) => {
  return (dispatch) => {
    if (doLog()) console.log("transactions_actions.fetchIncidentDetails");
    dispatch(fetchIncidentDetailsStart());
    const transaction = "ciddb";
    const jsonResult = true;
    const timeoutSecs = 10;
    const requestData = {
      transactionType: transaction,
      options: "GetCitizenIncidentDetails~" + ori + "~" + id,
      //example options: "GetCitizenIncidentDetails~MI23COR9Y~83",
      timeoutSecs: timeoutSecs,
      jsonResult: jsonResult,
    };

    const options = {
      timeout: 5000, // 5 seconds idle timeout
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    // const url = "transaction/citizenweb";
    const url = "transaction/" + getServerAppPath();

    if (doLog())
      console.log(
        "transactions_actions.fetchIncidentDetails requestData:",
        requestData
      );

    axios
      .post(url, requestData, options)
      .then((response) => {
        //if (doLog()) console.log(response);
        let responseData = response.data;
        //if (doLog()) console.log('responseData:',responseData);
        //if (doLog()) console.log('response:',response);
        if (typeof responseData === "string" && !responseData.startsWith("{")) {
          let pos = responseData.indexOf("{");
          //if (doLog()) console.log('pos:',pos);
          if (pos !== -1) {
            responseData = JSON.parse(responseData.substring(pos));
            //if (doLog()) console.log('new responseData:',responseData);
          }
        }
        if (doLog())
          console.log(
            "transactions_actions.fetchIncidentDetails responseData:",
            responseData
          );
        let message = "";
        if (response === "") {
          dispatch(fetchIncidentDetailsFail("Error sending request"));
        } else if (responseData.status === "Failure") {
          message = responseData.result;
          if (doLog()) console.log("message:", message);
          dispatch(fetchIncidentDetailsFail(message));
        } else {
          if (doLog()) console.log("result:", responseData.result);
          const fetchedList = [];
          for (let key in responseData.result) {
            const data = responseData.result[key];
            // if (doLog()) console.log('key:',key);
            // if (doLog()) console.log('data:',data);
            fetchedList.push({
              data: data,
            });
          }
          dispatch(fetchIncidentDetailsSuccess(fetchedList));
        }
      })
      .catch((err) => {
        // if (doLog()) console.log('[fetchIncidentDetailsFail] err:', err);
        dispatch(fetchIncidentDetailsFail(err));
      });
  };
};

export const setSharedIncidentDetails = (sharedIncidentDetails) => {
  if (doLog())
    console.log("[transactions_actions] sharedIncidentDetails:", sharedIncidentDetails);
  return {
    type: actionTypes.SET_SHARED_INCIDENT_DETAILS,
    sharedIncidentDetails: sharedIncidentDetails,
  };
};

//--------------------------------------------------------------------------------------
export const addToRequiredFieldArray = (item) => {
  // if (doLog()) console.log("[addToRequiredFieldArray actions] item:", item);
  return {
    type: actionTypes.ADD_TO_REQUIREDFIELD_ARRAY,
    item: item,
  };
};

export const setRequiredFieldArray = (requiredFieldArray) => {
  return {
    type: actionTypes.SET_REQUIREDFIELD_ARRAY,
    requiredFieldArray: requiredFieldArray,
  };
};

export const clearRequiredFieldList = () => {
  return {
    type: actionTypes.CLEAR_REQUIREDFIELD_LIST,
    requiredFieldList: null,
  };
};

export const fetchRequiredFieldListStart = () => {
  // if (doLog()) console.log('transactions_actions.fetchRequiredTextListStart');
  return {
    type: actionTypes.FETCH_REQUIREDFIELD_LIST_START,
  };
};

export const fetchRequiredFieldListSuccess = (requiredFieldList) => {
  // if (doLog()) console.log(
  //   "transactions_actions.fetchRequiredFieldListSuccess requiredFieldList:",
  //   requiredFieldList
  // );
  return {
    type: actionTypes.FETCH_REQUIREDFIELD_LIST_SUCCESS,
    requiredFieldList: requiredFieldList,
  };
};

export const fetchRequiredFieldListFail = (error) => {
  if (doLog())
    console.log(
      "transactions_actions.fetchRequiredFieldListFail error:",
      error
    );
  return {
    type: actionTypes.FETCH_REQUIREDFIELD_LIST_FAIL,
    requiredFieldErrorMsg: error,
    requiredFieldList: [],
  };
};

export const fetchRequiredFieldList = (ori, token, type) => {
  return (dispatch) => {
    if (doLog()) console.log("transactions_actions.fetchRequiredFieldList");
    dispatch(fetchRequiredFieldListStart());
    const transaction = "ciddb";
    const jsonResult = true;
    const timeoutSecs = 10;
    const requestData = {
      transactionType: transaction,
      options: "GetCitizenIncidentRequiredFields~" + ori + "~" + type,
      timeoutSecs: timeoutSecs,
      jsonResult: jsonResult,
    };

    const options = {
      timeout: 5000, // 5 seconds idle timeout
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    // const url = "transaction/citizenweb";
    const url = "transaction/" + getServerAppPath();

    if (doLog())
      console.log(
        "transactions_actions.fetchRequiredFieldList requestData:",
        requestData
      );

    axios
      .post(url, requestData, options)
      .then((response) => {
        //if (doLog()) console.log(response);
        let responseData = response.data;
        //if (doLog()) console.log('responseData:',responseData);
        //if (doLog()) console.log('response:',response);
        if (typeof responseData === "string" && !responseData.startsWith("{")) {
          let pos = responseData.indexOf("{");
          //if (doLog()) console.log('pos:',pos);
          if (pos !== -1) {
            responseData = JSON.parse(responseData.substring(pos));
            //if (doLog()) console.log('new responseData:',responseData);
          }
        }
        if (doLog())
          console.log(
            "transactions_actions.fetchRequiredFieldList responseData:",
            responseData
          );
        let message = "";
        if (response === "") {
          dispatch(fetchRequiredFieldListFail("Error sending request"));
        } else if (responseData.status === "Failure") {
          message = responseData.result;
          if (doLog()) console.log("message:", message);
          dispatch(fetchRequiredFieldListFail(message));
        } else {
          // if (doLog()) console.log("result:", responseData.result);
          const fetchedList = [];
          for (let key in responseData.result) {
            const data = responseData.result[key];
            // if (doLog()) console.log('key:',key);
            // if (doLog()) console.log('data:',data);
            fetchedList.push({
              data: data,
            });
            // array.push(data);
          }
          dispatch(fetchRequiredFieldListSuccess(fetchedList));
        }
      })
      .catch((err) => {
        // if (doLog()) console.log('[fetchRequiredFieldListFail] err:', err);
        dispatch(fetchRequiredFieldListFail(err));
      });
  };
};

//--------------------------------------------------------------------------------------
export const fetchDefaultRequiredFieldListStart = () => {
  // if (doLog()) console.log('[fetchDefaultRequiredFieldListStart]');
  return {
    type: actionTypes.FETCH_DEFAULTREQUIREDFIELD_LIST_START,
  };
};

export const fetchDefaultRequiredFieldListSuccess = (
  defaultRequiredFieldList
) => {
  // if (doLog()) console.log(
  //   "[fetchDefaultRequiredFieldListSuccess]defaultRequiredFieldList:",
  //   defaultRequiredFieldList
  // );
  return {
    type: actionTypes.FETCH_DEFAULTREQUIREDFIELD_LIST_SUCCESS,
    defaultRequiredFieldList: defaultRequiredFieldList,
  };
};

export const fetchDefaultRequiredFieldListFail = (error) => {
  if (doLog()) console.log("[fetchDefaultRequiredFieldListFail] error:", error);
  return {
    type: actionTypes.FETCH_DEFAULTREQUIREDFIELD_LIST_FAIL,
    defaultRequiredFieldErrorMsg: error,
  };
};

export const fetchDefaultRequiredFieldList = (ori, token, type) => {
  return (dispatch) => {
    if (doLog())
      console.log("transactions_actions.fetchDefaultRequiredFieldList");
    dispatch(fetchDefaultRequiredFieldListStart());
    const transaction = "ciddb";
    const jsonResult = true;
    const timeoutSecs = 10;
    const requestData = {
      transactionType: transaction,
      options: "GetCitizenIncidentRequiredFields~MI9999999~SAMPLETYPE",
      timeoutSecs: timeoutSecs,
      jsonResult: jsonResult,
    };

    const options = {
      timeout: 5000, // 5 seconds idle timeout
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    // const url = "transaction/citizenweb";
    const url = "transaction/" + getServerAppPath();

    if (doLog())
      console.log(
        "transactions_actions.fetchRequiredFieldList requestData:",
        requestData
      );

    axios
      .post(url, requestData, options)
      .then((response) => {
        //if (doLog()) console.log(response);
        let responseData = response.data;
        //if (doLog()) console.log('responseData:',responseData);
        //if (doLog()) console.log('response:',response);
        if (typeof responseData === "string" && !responseData.startsWith("{")) {
          let pos = responseData.indexOf("{");
          //if (doLog()) console.log('pos:',pos);
          if (pos !== -1) {
            responseData = JSON.parse(responseData.substring(pos));
            //if (doLog()) console.log('new responseData:',responseData);
          }
        }
        if (doLog())
          console.log(
            "transactions_actions.fetchDefaultRequiredFieldList responseData:",
            responseData
          );
        let message = "";
        if (response === "") {
          dispatch(fetchDefaultRequiredFieldListFail("Error sending request"));
        } else if (responseData.status === "Failure") {
          message = responseData.result;
          if (doLog()) console.log("message:", message);
          dispatch(fetchDefaultRequiredFieldListFail(message));
        } else {
          // if (doLog()) console.log("result:", responseData.result);
          const fetchedList = [];
          for (let key in responseData.result) {
            const data = responseData.result[key];
            fetchedList.push({
              data: data,
            });
          }
          dispatch(fetchDefaultRequiredFieldListSuccess(fetchedList));
        }
      })
      .catch((err) => {
        // if (doLog()) console.log('[fetchDefaultRequiredFieldListFail] err:', err);
        dispatch(fetchDefaultRequiredFieldListFail(err));
      });
  };
};

//--------------------------------------------------------------------------------------
export const clearValidCodeList = (listName) => {
  return {
    type: actionTypes.CLEAR_VALIDCODE_LIST,
    listName: listName,
  };
};

export const fetchValidCodeListsStart = (listName) => {
  // if (doLog()) console.log('[fetchValidCodeListsStart]');
  return {
    type: actionTypes.FETCH_VALIDCODE_LISTS_START,
    listName: listName,
  };
};

export const fetchValidCodeListsSuccess = (listName, list) => {
  if (doLog())
    console.log("[fetchValidCodeListsSuccess.actions]" + listName + ":", list);
  return {
    type: actionTypes.FETCH_VALIDCODE_LISTS_SUCCESS,
    listName: listName,
    list: list,
  };
};

export const fetchValidCodeListsFail = (listNameErrMsg, error) => {
  if (doLog()) console.log("[fetchValidCodeListsFail] error:", error);
  return {
    type: actionTypes.FETCH_VALIDCODE_LISTS_FAIL,
    [listNameErrMsg]: error,
  };
};

export const fetchValidCodeLists = (
  ori,
  token,
  listName,
  codeGroup,
  allFields,
  includeInactive
) => {
  return (dispatch) => {
    if (doLog()) console.log("transactions_actions.fetchValidCodeLists");
    dispatch(fetchValidCodeListsStart(listName));
    const listNameErrMsg = listName + "ErrMsg";
    const transaction = "ciddb";
    const jsonResult = true;
    const timeoutSecs = 10;
    const requestData = {
      transactionType: transaction,
      options:
        "GetValidCodeListData~" +
        ori +
        "~" +
        codeGroup +
        "~" +
        allFields +
        "~" +
        includeInactive,
      timeoutSecs: timeoutSecs,
      jsonResult: jsonResult,
    };

    const options = {
      timeout: 5000, // 5 seconds idle timeout
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    if (doLog())
      console.log(
        "transactions_actions.fetchValidCodeLists serverAppPath:",
        getServerAppPath()
      );
    // const url = "transaction/citizenweb";
    const url = "transaction/" + getServerAppPath();

    if (doLog())
      console.log(
        "transactions_actions.fetchValidCodeLists requestData:",
        requestData
      );

    axios
      .post(url, requestData, options)
      .then((response) => {
        //if (doLog()) console.log(response);
        let responseData = response.data;
        //if (doLog()) console.log('responseData:',responseData);
        //if (doLog()) console.log('response:',response);
        if (typeof responseData === "string" && !responseData.startsWith("{")) {
          let pos = responseData.indexOf("{");
          //if (doLog()) console.log('pos:',pos);
          if (pos !== -1) {
            responseData = JSON.parse(responseData.substring(pos));
            //if (doLog()) console.log('new responseData:',responseData);
          }
        }
        if (doLog())
          console.log(
            "transactions_actions.fetchValidCodeLists responseData:",
            responseData
          );
        let message = "";
        if (response === "") {
          dispatch(
            fetchValidCodeListsFail(listNameErrMsg, "Error sending request")
          );
        } else if (responseData.status === "Failure") {
          message = responseData.result;
          if (doLog()) console.log("message:", message);
          dispatch(fetchValidCodeListsFail(listNameErrMsg, message));
        } else {
          if (doLog()) console.log("result:", responseData.result);
          const fetchedList = [];
          if (hasValue(allFields) && allFields === true) {
            dispatch(fetchValidCodeListsSuccess(listName, responseData.result));
          } else {
            for (let key in responseData.result) {
              const data = responseData.result[key];
              // if (doLog()) console.log('key:',key);
              // if (doLog()) console.log('data:',data);
              fetchedList.push({
                value: data.CODEVALUE,
                label: data.DESCRIPTION,
              });
            }
            dispatch(fetchValidCodeListsSuccess(listName, fetchedList));
          }
        }
      })
      .catch((err) => {
        // if (doLog()) console.log('[fetchValidCodeListsFail] err:', err);
        dispatch(fetchValidCodeListsFail(listNameErrMsg, err));
      });
  };
};

//--------------------------------------------------------------------------------------
export const fetchMultipleValidCodeListsStart = (listOptions) => {
  // if (doLog()) console.log('[fetchMultipleValidCodeListsStart]');
  return {
    type: actionTypes.FETCH_MULTIPLE_VALIDCODE_LISTS_START,
    listOptions: listOptions,
  };
};

export const fetchMultipleValidCodeListsSuccess = (listName, list) => {
  if (doLog()) console.log("[fetchMultipleValidCodeListsSuccess.actions]");
  return {
    type: actionTypes.FETCH_MULTIPLE_VALIDCODE_LISTS_SUCCESS,
    listName: listName,
    list: list,
  };
};

export const fetchMultipleValidCodeListsFail = (listNameErrMsg, error) => {
  if (doLog()) console.log("[fetchMultipleValidCodeListsFail] error:", error);
  return {
    type: actionTypes.FETCH_MULTIPLE_VALIDCODE_LISTS_FAIL,
    [listNameErrMsg]: error,
  };
};

export const fetchMultipleValidCodeLists = (ori, token, listOptions) => {
  return (dispatch) => {
    if (doLog())
      console.log("transactions_actions.fetchMultipleValidCodeLists");
    dispatch(fetchMultipleValidCodeListsStart(listOptions));
    const listNameErrMsg = "MultipleValidCodeListsErrMsg";
    const transaction = "ciddb";
    const jsonResult = true;
    const timeoutSecs = 10;
    const requestData = {
      transactionType: transaction,
      options: "GetMultipleValidCodeLists~" + ori + "~" + listOptions,
      timeoutSecs: timeoutSecs,
      jsonResult: jsonResult,
    };

    const options = {
      timeout: 5000, // 5 seconds idle timeout
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    if (doLog())
      console.log(
        "transactions_actions.fetchMultipleValidCodeLists serverAppPath:",
        getServerAppPath()
      );
    // const url = "transaction/citizenweb";
    const url = "transaction/" + getServerAppPath();

    if (doLog())
      console.log(
        "transactions_actions.fetchMultipleValidCodeLists requestData:",
        requestData
      );

    axios
      .post(url, requestData, options)
      .then((response) => {
        //if (doLog()) console.log(response);
        let responseData = response.data;
        //if (doLog()) console.log('responseData:',responseData);
        //if (doLog()) console.log('response:',response);
        if (typeof responseData === "string" && !responseData.startsWith("{")) {
          let pos = responseData.indexOf("{");
          //if (doLog()) console.log('pos:',pos);
          if (pos !== -1) {
            responseData = JSON.parse(responseData.substring(pos));
            //if (doLog()) console.log('new responseData:',responseData);
          }
        }
        if (doLog())
          console.log(
            "transactions_actions.fetchMultipleValidCodeLists responseData:",
            responseData
          );
        let message = "";
        if (response === "") {
          dispatch(
            fetchMultipleValidCodeListsFail(
              listNameErrMsg,
              "Error sending request"
            )
          );
        } else if (responseData.status === "Failure") {
          message = responseData.result;
          if (doLog()) console.log("message:", message);
          dispatch(fetchMultipleValidCodeListsFail(listNameErrMsg, message));
        } else {
          if (doLog())
            console.log(
              "transactions_actions.fetchMultipleValidCodeLists result:",
              responseData.result
            );
          //TODO:
          // loop through the result elements
          //   get the name as the list name
          //   build fetchedList with the elements with the result element
          //   dispatch(fetchValidCodeListsSuccess(listName, fetchedList)); for each one.
          for (let key in responseData.result) {
            let listName = key;
            const fetchedList = [];
            const data = responseData.result[key];
            if (doLog())
              console.log(
                "transactions_actions.fetchMultipleValidCodeLists listName:" +
                  listName +
                  " data:",
                data
              );
            if (hasValue(data)) {
              const len = data.length;
              for (let i = 0; i < len; i++) {
                const row = data[i];
                fetchedList.push({
                  value: row.CODEVALUE,
                  label: row.DESCRIPTION,
                });
              }
              dispatch(fetchValidCodeListsSuccess(listName, fetchedList));
            }
          }
          dispatch(fetchMultipleValidCodeListsSuccess("", null));
        }
      })
      .catch((err) => {
        // if (doLog()) console.log('[fetchValidCodeListsFail] err:', err);
        dispatch(fetchMultipleValidCodeListsFail(listNameErrMsg, err));
      });
  };
};

//--------------------------------------------------------------------------------------
export const setConfigurationDefaults = (configuration) => {
  if (doLog())
    console.log("[setConfigurationDefaults] configuration:", configuration);
  return {
    type: actionTypes.SET_CONFIGURATION_DEFAULTS,
    configuration: configuration,
  };
};

export const setAgencyCode = (agencyCode) => {
  return {
    type: actionTypes.SET_AGENCYCODE,
    agencyCode,
  };
};

export const setServerInfo = (baseURL, pathname) => {
  if (doLog())
    console.log("[setBaseURL] baseURL:" + baseURL + " pathname:" + pathname);
  return {
    type: actionTypes.SET_SERVERINFO,
    baseURL: baseURL,
    pathname: pathname,
  };
};

export const setIncidentTypeData = (selectedIncidentTypeData) => {
  return {
    type: actionTypes.SET_INCIDENTTYPEDATA,
    selectedIncidentTypeData: selectedIncidentTypeData,
  };
};

//--------------------------------------------------------------------------------------
export const addToAttachmentArray = (attachmentArray, attachmentItem) => {
  if (doLog())
    console.log("[addToAttachmentArray actions] item:", attachmentItem);
  const newArray = [...attachmentArray];
  newArray.push(attachmentItem);
  if (doLog())
    console.log("[addToAttachmentArray actions] newArray:", newArray);
  return {
    type: actionTypes.ADD_TO_ATTACHMENT_ARRAY,
    attachmentArray: newArray,
  };
};

export const deleteFromAttachmentArray = (attachmentArray, attachmentItem) => {
  if (doLog())
    console.log(
      "[deleteFromAttachmentArray actions] attachmentArray:",
      attachmentArray
    );
  if (doLog())
    console.log("[deleteFromAttachmentArray actions] item:", attachmentItem);
  const newArray = attachmentArray.filter(
    (item) => item.attachmentInstance !== attachmentItem.attachmentInstance
  );
  if (doLog())
    console.log("[deleteFromAttachmentArray actions] newArray:", newArray);
  return {
    type: actionTypes.DELETE_FROM_ATTACHMENT_ARRAY,
    attachmentArray: newArray,
  };
};

export const setAttachmentArray = (attachmentArray) => {
  return {
    type: actionTypes.SET_ATTACHMENT_ARRAY,
    attachmentArray: attachmentArray,
  };
};

export const setAttachmentSelectFieldList = (attachmentSelectFieldList) => {
  if (doLog())
    console.log(
      "[setAttachmentSelectFieldList] attachmentSelectFieldList:",
      attachmentSelectFieldList
    );
  return {
    type: actionTypes.SET_ATTACHMENT_SELECT_FIELDLIST,
    attachmentSelectFieldList: attachmentSelectFieldList,
  };
};

export const setAttachmentTextFieldList = (attachmentTextFieldList) => {
  if (doLog())
    console.log(
      "[setAttachmentTextFieldList] attachmentTextFieldList:",
      attachmentTextFieldList
    );
  return {
    type: actionTypes.SET_ATTACHMENT_TEXT_FIELDLIST,
    attachmentTextFieldList: attachmentTextFieldList,
  };
};

//--------------------------------------------------------------------------------------
export const addToPersonArray = (personArray, personItem) => {
  if (doLog()) console.log("[addToPersonArray actions] item:", personItem);
  const newArray = [...personArray];
  newArray.push(personItem);
  if (doLog()) console.log("[addToPersonArray actions] newArray:", newArray);
  return {
    type: actionTypes.ADD_TO_PERSON_ARRAY,
    personArray: newArray,
  };
};

export const deleteFromPersonArray = (personArray, personItem) => {
  if (doLog())
    console.log("[deleteFromPersonArray actions] personArray:", personArray);
  if (doLog()) console.log("[deleteFromPersonArray actions] item:", personItem);
  const newArray = personArray.filter(
    (item) => item.personInstance !== personItem.personInstance
  );
  if (doLog())
    console.log("[deleteFromPersonArray actions] newArray:", newArray);
  return {
    type: actionTypes.DELETE_FROM_PERSON_ARRAY,
    personArray: newArray,
  };
};

export const setPersonArray = (personArray) => {
  if (doLog())
    console.log("[setPersonArray actions] personArray:", personArray);
  return {
    type: actionTypes.SET_PERSON_ARRAY,
    personArray: personArray,
  };
};

export const setPersonSelectFieldList = (personSelectFieldList) => {
  if (doLog())
    console.log(
      "[setPersonSelectFieldList] personSelectFieldList:",
      personSelectFieldList
    );
  return {
    type: actionTypes.SET_PERSON_SELECT_FIELDLIST,
    personSelectFieldList: personSelectFieldList,
  };
};

export const setPersonTextFieldList = (personTextFieldList) => {
  if (doLog())
    console.log(
      "[setPersonTextFieldList] personTextFieldList:",
      personTextFieldList
    );
  return {
    type: actionTypes.SET_PERSON_TEXT_FIELDLIST,
    personTextFieldList: personTextFieldList,
  };
};

//--------------------------------------------------------------------------------------
export const addToPropertyArray = (propertyArray, propertyItem) => {
  if (doLog()) console.log("[addToPropertyArray actions] item:", propertyItem);
  const newArray = [...propertyArray];
  newArray.push(propertyItem);
  if (doLog()) console.log("[addToPropertyArray actions] newArray:", newArray);
  return {
    type: actionTypes.ADD_TO_PROPERTY_ARRAY,
    propertyArray: newArray,
  };
};

export const deleteFromPropertyArray = (propertyArray, propertyItem) => {
  if (doLog())
    console.log(
      "[deleteFromPropertyArray actions] propertyArray:",
      propertyArray
    );
  if (doLog())
    console.log("[deleteFromPropertyArray actions] item:", propertyItem);
  const newArray = propertyArray.filter(
    (item) => item.propertyInstance !== propertyItem.propertyInstance
  );
  if (doLog())
    console.log("[deleteFromPropertyArray actions] newArray:", newArray);
  return {
    type: actionTypes.DELETE_FROM_PROPERTY_ARRAY,
    propertyArray: newArray,
  };
};

export const setPropertyArray = (propertyArray) => {
  return {
    type: actionTypes.SET_PROPERTY_ARRAY,
    propertyArray: propertyArray,
  };
};

export const setPropertySelectFieldList = (propertySelectFieldList) => {
  if (doLog())
    console.log(
      "[setPropertySelectFieldList] propertySelectFieldList:",
      propertySelectFieldList
    );
  return {
    type: actionTypes.SET_PROPERTY_SELECT_FIELDLIST,
    propertySelectFieldList: propertySelectFieldList,
  };
};

export const setPropertyTextFieldList = (propertyTextFieldList) => {
  if (doLog())
    console.log(
      "[setPropertyTextFieldList] propertyTextFieldList:",
      propertyTextFieldList
    );
  return {
    type: actionTypes.SET_PROPERTY_TEXT_FIELDLIST,
    propertyTextFieldList: propertyTextFieldList,
  };
};

//--------------------------------------------------------------------------------------
export const addToVehicleArray = (vehicleArray, vehicleItem) => {
  if (doLog()) console.log("[addToVehicleArray actions] item:", vehicleItem);
  const newArray = [...vehicleArray];
  newArray.push(vehicleItem);
  if (doLog()) console.log("[addToVehicleArray actions] newArray:", newArray);
  return {
    type: actionTypes.ADD_TO_VEHICLE_ARRAY,
    vehicleArray: newArray,
  };
};

export const deleteFromVehicleArray = (vehicleArray, vehicleItem) => {
  if (doLog())
    console.log("[deleteFromVehicleArray actions] vehicleArray:", vehicleArray);
  if (doLog())
    console.log("[deleteFromVehicleArray actions] item:", vehicleItem);
  const newArray = vehicleArray.filter(
    (item) => item.vehicleInstance !== vehicleItem.vehicleInstance
  );
  if (doLog())
    console.log("[deleteFromVehicleArray actions] newArray:", newArray);
  return {
    type: actionTypes.DELETE_FROM_VEHICLE_ARRAY,
    vehicleArray: newArray,
  };
};

export const setVehicleArray = (vehicleArray) => {
  return {
    type: actionTypes.SET_VEHICLE_ARRAY,
    vehicleArray: vehicleArray,
  };
};

export const setVehicleSelectFieldList = (vehicleSelectFieldList) => {
  if (doLog())
    console.log(
      "[setVehicleSelectFieldList] vehicleSelectFieldList:",
      vehicleSelectFieldList
    );
  return {
    type: actionTypes.SET_VEHICLE_SELECT_FIELDLIST,
    vehicleSelectFieldList: vehicleSelectFieldList,
  };
};

export const setVehicleTextFieldList = (vehicleTextFieldList) => {
  if (doLog())
    console.log(
      "[setVehicleTextFieldList] vehicleTextFieldList:",
      vehicleTextFieldList
    );
  return {
    type: actionTypes.SET_VEHICLE_TEXT_FIELDLIST,
    vehicleTextFieldList: vehicleTextFieldList,
  };
};

//--------------------------------------------------------------------------------------
export const fetchReportListStart = () => {
  if (doLog()) console.log("[fetchReportListStart]");
  return {
    type: actionTypes.FETCH_REPORT_LIST_START,
  };
};

export const fetchReportListSuccess = (reportList) => {
  if (doLog()) console.log("[fetchReportListSuccess] reportList:", reportList);
  return {
    type: actionTypes.FETCH_REPORT_LIST_SUCCESS,
    reportList: reportList,
  };
};

export const fetchReportListFail = (error) => {
  if (doLog()) console.log("[fetchReportListFail] error:", error);
  return {
    type: actionTypes.FETCH_REPORT_LIST_FAIL,
    reportListErrorMsg: error,
  };
};

export const fetchReportList = (token) => {
  return (dispatch) => {
    if (doLog()) console.log("transactions_actions.fetchReportList");
    dispatch(fetchReportListStart());
    const transaction = "ciddb";
    const jsonResult = true;
    const timeoutSecs = 10;
    const requestData = {
      transactionType: transaction,
      options: "GetCitizenReportDefinitions",
      timeoutSecs: timeoutSecs,
      jsonResult: jsonResult,
    };

    const options = {
      timeout: 5000, // 5 seconds idle timeout
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    // const url = "transaction/citizenweb";
    const url = "transaction/" + getServerAppPath();

    if (doLog())
      console.log(
        "transactions_actions.fetchReportList requestData:",
        requestData
      );

    axios
      .post(url, requestData, options)
      .then((response) => {
        if (doLog()) console.log("response:", response);
        let responseData = "";
        if (response === "") {
          dispatch(fetchReportListFail("Error sending request"));
        } else {
          responseData = response.data;
          if (doLog()) console.log("responseData:", responseData);
        }
        let message = "";
        if (
          hasValue(responseData.status) &&
          responseData.status === "Failure"
        ) {
          message = responseData.result;
          if (doLog()) console.log("message:", message);
          dispatch(fetchReportListFail(message));
        } else {
          // const fetchedList = [];
          // for (let key in responseData.result) {
          //   const data = responseData.result[key];
          //   // if (doLog()) console.log('key:',key);
          //   // if (doLog()) console.log('data:',data);
          //   fetchedList.push({
          //     data: data,
          //   });
          // }
          const parser = new DOMParser();
          let xmlDoc = parser.parseFromString(responseData, "text/xml");
          let reportElements = xmlDoc.getElementsByTagName("Report");

          dispatch(fetchReportListSuccess(reportElements));
        }
      })
      .catch((err) => {
        // if (doLog()) console.log('[fetchReportListFail] err:', err);
        dispatch(fetchReportListFail(err));
      });
  };
};

//--------------------------------------------------------------------------------------
export const runReportStart = () => {
  return {
    type: actionTypes.REPORT_START,
    result: null,
    error: null,
  };
};

export const runReportSuccess = (result) => {
  // if (doLog()) console.log('[transactions.authSuccess] result:', result);
  return {
    type: actionTypes.REPORT_SUCCESS,
    reportResult: result,
    reportError: null,
  };
};

export const runReportFail = (error) => {
  return {
    type: actionTypes.REPORT_FAIL,
    resultError: error,
  };
};

export const clearReportResult = () => {
  return {
    type: actionTypes.CLEAR_REPORT_RESULT,
    reportResult: null,
    reportError: null,
  };
};

export const runReport = (
  transactionOptions,
  jsonResult,
  timeoutSecs,
  connectionName,
  token
) => {
  return (dispatch) => {
    dispatch(runReportStart());
    const requestData = {
      connectionName: connectionName,
      transactionType: "RunReports",
      options: transactionOptions,
      timeoutSecs: timeoutSecs,
      jsonResult: jsonResult,
    };

    const options = {
      timeout: 10000, // 10 seconds idle timeout
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    // const url = "transaction/citizenweb";
    const url = "transaction/" + getServerAppPath();

    if (doLog()) console.log("[runReport] requestData:", requestData);

    axios
      .post(url, requestData, options)
      .then((response) => {
        if (doLog()) console.log(response);
        let responseData = response.data;
        if (doLog()) console.log("[runReport] responseData:", responseData);
        dispatch(runReportSuccess(responseData));
      })
      .catch((err) => {
        if (doLog()) console.log("[runReport] err:", err);
        dispatch(runReportFail(err));
      });
  };
};

//--------------------------------------------------------------------------------------
export const upLoadFileStart = () => {
  return {
    type: actionTypes.UPLOAD_FILE_START,
    upLoadFileresult: null,
    upLoadFileError: null,
  };
};

export const upLoadFileSuccess = (result, index) => {
  if (doLog()) console.log("[transactions.upLoadFileSuccess] result:", result);
  if (doLog()) console.log("[transactions.upLoadFileSuccess] index:", index);
  return {
    type: actionTypes.UPLOAD_FILE_SUCCESS,
    upLoadNextIndex: index,
    upLoadFileResult: result,
    upLoadFileError: null,
  };
};

export const upLoadFileFail = (error) => {
  return {
    type: actionTypes.UPLOAD_FILE_FAIL,
    upLoadFileError: error,
  };
};

export const upLoadFile = (formData, token, index) => {
  return (dispatch) => {
    dispatch(upLoadFileStart());

    const options = {
      timeout: 30000, // 30 seconds idle timeout
      headers: {
        "content-type": "multipart/form-data",
        Authorization: "Bearer " + token,
      },
    };

    // const url = "transaction/citizenweb";
    const url = "transaction/" + getServerAppPath();

    if (doLog()) console.log("[upLoadFile] formData:", formData);

    axios
      .post(url, formData, options)
      .then((response) => {
        if (doLog()) console.log(response);
        let responseData = response.data;
        if (doLog()) console.log("[upLoadFile] responseData:", responseData);
        if (doLog()) console.log("[upLoadFile] index:", index);
        dispatch(upLoadFileSuccess(responseData, index + 1));
      })
      .catch((err) => {
        if (doLog()) console.log("[upLoadFile]  err:", err);
        dispatch(upLoadFileFail(err));
      });
  };
};

export const clearUpLoadResult = () => {
  return {
    type: actionTypes.CLEAR_UPLOAD_RESULT,
    upLoadNextIndex: 0,
    upLoadFileResult: null,
    upLoadFileError: null,
  };
};
